const showroomSection = `
  <div class="showroom">
    <div class="showroom__info">
      <div class="showroom__subheadline subheadline">
        Showroom
      </div>
      <div class="showroom__headline h1">
        Kde nás najdete a jak nás můžete zastihnout?
      </div>
      <div class="showroom__text">
        <p>Náš showroom – kamenný obchod je v Praze na Kavčích horách, kousek od České televize. Pokud nás nezastihnete během otevírací doby, můžete kdykoli navštívit náš e-shop. Naleznete zde bohatou nabídku produktů, které máme ihned skladem a odešleme Vám je do druhého pracovního dne.</p>
      </div>
      <div class="showroom__contacts">
        <div class="showroom__column">
          <div class="showroom__contact">
            <div class="showroom__icon">
              <img src="/user/documents/img/ico-pin-white.svg" />
            </div>
            <p>
              Na Klaudiánce 781/19<br/>
              147 00 Praha 4
            </p>
          </div>  
          <div class="showroom__contact">
            <div class="showroom__icon">
              <img src="/user/documents/img/ico-phone-white.svg" />
            </div>
            <p>
              <a href="tel:+420252546399">+420 252 546 399</a>
            </p>
          </div>  
          <div class="showroom__contact">
            <div class="showroom__icon">
              <img src="/user/documents/img/ico-mail-white.svg" />
            </div>
            <p>
              <a href="mailto:obchod@futurecycling.cz">obchod@futurecycling.cz</a>
            </p>
          </div>  
        </div>
        <div class="showroom__column">
          <div class="showroom__contact showroom__contact--week">
            <div class="showroom__icon">
              <img src="/user/documents/img/ico-clock-white.svg" />
            </div>
            <div class="showroom__open-hours">
              <p>
                <span>Pondělí:</span>9&nbsp;-&nbsp;17h
              </p>
              <p>
                <span>Úterý:</span>9&nbsp;-&nbsp;17h
              </p>
              <p>
                <span>Středa:</span>9&nbsp;-&nbsp;19h
              </p>
              <p>
                <span>Čtvrtek:</span>9&nbsp;-&nbsp;17h
              </p>
              <p>
                <span>Pátek:</span>9&nbsp;-&nbsp;17h
              </p>
            </div>
          </div>  
        </div>
      </div>
    </div>
    <div class="showroom__hero">
      <a href="https://goo.gl/maps/TMm2Vj7VntiTc94z6" target="_blank"><img src="/user/documents/img/showroom-map.png" /></a>
    </div>
  </div>
`;

export {
  showroomSection
};